import axiosInstance from './axiosInstance';

export type SellerInAppNotificationType =
  | 'NEW_ORDER'
  | 'PAYOUT_UPDATE'
  | 'ACHIEVEMENT'
  | 'MILESTONE'
  | 'WEEKLY_RECAP';

export type SellerInAppNotification = {
  id: string;
  type: SellerInAppNotificationType;
  title: string;
  body: string;
  href: string;
  metadata: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
};

export type SellerNotificationsListResponse = {
  items: SellerInAppNotification[];
  total: number;
  unreadCount: number;
};

export const sellerNotificationsService = {
  async list(params?: {
    limit?: number;
    offset?: number;
    unreadOnly?: boolean;
  }): Promise<SellerNotificationsListResponse> {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.offset != null) search.set('offset', String(params.offset));
    if (params?.unreadOnly) search.set('unreadOnly', 'true');
    const q = search.toString();
    const response = await axiosInstance.get<SellerNotificationsListResponse>(
      `/seller/notifications${q ? `?${q}` : ''}`,
    );
    return response.data;
  },

  async unreadCount(): Promise<number> {
    const response = await axiosInstance.get<{ count: number }>(
      '/seller/notifications/unread-count',
    );
    return response.data.count;
  },

  async markRead(id: string): Promise<SellerInAppNotification> {
    const response = await axiosInstance.patch<SellerInAppNotification>(
      `/seller/notifications/${id}/read`,
    );
    return response.data;
  },

  async markAllRead(): Promise<{ updated: number }> {
    const response = await axiosInstance.post<{ updated: number }>(
      '/seller/notifications/read-all',
    );
    return response.data;
  },
};
